import * as React from 'react';

import { TagContent } from './tag-content';
import * as Styled from './tag.styles';
import type { PlaceholderTagProps } from './tag.types';

export const PlaceholderTag = React.forwardRef<
  HTMLDivElement,
  PlaceholderTagProps
>(
  (
    {
      children,
      className,
      fontWeight,
      leadingIcon: LeadingIcon,
      maxWidth = '330px',
      profile,
      trailingIcon: TrailingIcon,
      ...props
    },
    forwardedRef
  ): JSX.Element => {
    const hasChildren = Boolean(children);
    const hasLeadingContent =
      !hasChildren || Boolean(LeadingIcon) || Boolean(profile);
    const hasTrailingContent = !hasChildren || Boolean(TrailingIcon);

    return (
      <Styled.PlaceholderTag
        $fontWeight={fontWeight}
        $hasLeadingContent={hasLeadingContent}
        $hasTrailingContent={hasTrailingContent}
        className={className}
        data-xds="PlaceholderTag"
        ref={forwardedRef}
        {...props}
      >
        <TagContent
          badgeProps={undefined}
          disabled={false}
          leadingIcon={LeadingIcon && <LeadingIcon width={18} height={18} />}
          maxWidth={maxWidth}
          profile={profile}
          selected={false}
          trailingIcon={TrailingIcon && <TrailingIcon width={18} height={18} />}
        >
          {children}
        </TagContent>
      </Styled.PlaceholderTag>
    );
  }
);

PlaceholderTag.displayName = 'PlaceholderTag';
